import { useSelector } from "react-redux";
import Router from "next/router";

import KButton from "@kikoff/components/src/v1/buttons/KButton";

import { selectFeatureFlag } from "@feature/page";
import { track } from "@util/analytics";

import styles from "./styles.module.scss";

function SignupButton() {
  const signupEnabled = useSelector(
    selectFeatureFlag("sc_cash_card_only_signup")
  );

  return signupEnabled ? <CashCardSignupButton /> : <KikoffOnboardingButton />;
}

function CashCardSignupButton() {
  return (
    <button
      className={styles["cash-card-button"]}
      data-cy="cash-card-signup"
      onClick={() => {
        track.tap("Landing - Secured Card - Sign Up Button");
        Router.push("/cash-card-signup");
      }}
      type="submit"
    >
      <span>Sign up for Secured Credit Card</span>
    </button>
  );
}

function KikoffOnboardingButton() {
  return (
    <div className={styles["onboarding-button"]}>
      <KButton
        variant="primary"
        size="standard"
        onClick={() => {
          track.tap("Landing - Secured Card Hero - CTA");
          Router.replace("/onboarding");
        }}
      >
        <div className="color:white">Get started</div>
      </KButton>
    </div>
  );
}

export default SignupButton;
